// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomAppState } from "@flip/App/Store/Reducers";
import formatDateWithTimezone from "@insite/client-framework/Common/Utilities/formatDateWithTimezone";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateCart } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";

const convertDateToApiFormat = (date: Date | null) => (date ? formatDateWithTimezone(date) : "");

export const XngPopulateCart: typeof PopulateCart = props => {
    const {
        xCheckout: { shipWhenComplete, carrierAccountNo },
        pages: {
            checkoutReviewAndSubmit: { requestedDeliveryDate },
        },
    } = props.getState() as CustomAppState;

    const tempDeliveryDate = typeof requestedDeliveryDate !== "undefined" ? requestedDeliveryDate : null;

    props.cart = {
        ...props.cart,
        properties: {
            ...props.cart.properties,
            shipWhenComplete,
            shippingCarrierNumber: carrierAccountNo
        },
        requestedDeliveryDate: convertDateToApiFormat(tempDeliveryDate),
    };
};

addToChainAfter(chain, PopulateCart, XngPopulateCart);
